import React from 'react';
import { getIn, useFormikContext } from 'formik';

const ImageChoicePreview = ({ choice, index, sendSurvey, outOfDate }) => {
  const { setFieldValue, values, setFieldTouched } = useFormikContext();

  const currentValue = getIn(values, `employeeSurvey[employeeQuestionChoicesAttributes][${index}][questionChoiceId]`);
  const isSelected = currentValue && String(currentValue) === String(choice.id);

  const handleSelect = () => {
    if (!sendSurvey || outOfDate) return;
    setFieldTouched(`employeeSurvey[employeeQuestionChoicesAttributes][${index}][questionId]`);
    setFieldValue(`employeeSurvey[employeeQuestionChoicesAttributes][${index}][questionChoiceId]`, String(choice.id));
  };

  const imageUrl = typeof choice.imageUrl === 'string' 
    ? choice.imageUrl 
    : (choice.imageUrl?.fileUrl || choice.image_url?.file_url || null);

  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    <div
      onClick={handleSelect}
      className={`survey-preview-image-box ${sendSurvey && !outOfDate ? 'clickable' : 'not-clickable'} ${
        isSelected ? 'selected' : ''
      }`}
    >
      {imageUrl ? (
        <img src={imageUrl} alt={`opción ${choice.position || ''}`} className="survey-preview-image" />
      ) : (
        <div className="survey-preview-no-image">Sin imagen</div>
      )}
    </div>
  );
};

export default ImageChoicePreview;
